import styles from '../index.scss'
import { SafeArea } from 'antd-mobile'
import DpBusinessToolbar from '@/libs/components/DpBusinessComponents/DpBusinessToolbar'
import { DpButtonThemeConfig } from '@/libs/components'

export type IDpToolbarPropsType = {
  btnStyle?: React.CSSProperties
  tipsStyle?: React.CSSProperties
  customStyles?: React.CSSProperties
  onSubmit?: any
  h5Config?: any
  data?: {
    showTips?: boolean // 是否展示tips
    tips?: string // tips
    categoryType?: string // 类型，去订单详情直接筛选吧
  }
  isTheme?: boolean
  disabled?: boolean
  h5Setting?: {
    showServicePhone?: boolean // 是否开启平台电话
    servicePhoneContent?: any[], // 平台电话
    showHomePage?: boolean // 是否开启home
    homePagePath?: string // homeURl
    showOrderEntry?: boolean // 是否开启订单
    orderEntryName?: string // 订单名称
    orderEntryImg?: any[string]
    customerServiceTemplate?: any // 客服模板[string]
  }
  trackerPermission?: string[]
  msgType?: string
}
const Toolbar = (props: IDpToolbarPropsType) => {
  return (
    <footer className={styles["dp-business-commodity--fixTool"]} style={props?.customStyles}>
      <div className={styles["dp-business-commodity--tool"]}>
        { props?.data?.showTips &&
          <p className={styles["dp-business-commodity--tool-tips"]} style={props?.tipsStyle}>{props?.data?.tips}</p>
        }
        <DpBusinessToolbar {...props} />
        <DpButtonThemeConfig
          disabled={props?.disabled}
          buttonText={props?.h5Config?.equButtonWord || '下 一 步'}
          isTheme={props?.isTheme}
          onClick={props?.onSubmit}
          style={{ ...props?.btnStyle, borderWidth: 0 }}
        />
      </div>
      <SafeArea position="bottom" />
    </footer>
  )
}

export default Toolbar
